import createClient from 'openapi-fetch';
import type { Middleware } from 'openapi-fetch';
import createQueryClient from 'openapi-react-query';

import { env } from '@/shared/config';
import { useAuthStore } from '@/store/auth';

import type { paths } from './schema';

/**
 * Типобезопасный клиент по сгенерированной схеме бэкенда.
 *
 *   const { data } = useQuery('get', '/tasks/{id}', { params: { path: { id } } });
 *   const { mutate } = useMutation('post', '/tasks/add');
 *
 * Путь, метод, параметры и тело проверяются компилятором, тип ответа выводится
 * из спеки. Рядом продолжает жить axios-инстанс `http` — старые фетчеры на нём.
 */

/** Повторяет поведение response-интерсептора `http`: 401 → разлогин. */
const authMiddleware: Middleware = {
  onResponse({ response }) {
    if (
      response.status === 401 &&
      !env.authBypass &&
      window.location.pathname !== '/login'
    ) {
      useAuthStore.getState().logout();
    }

    return response;
  },
};

const client = createClient<paths>({
  baseUrl: `${env.apiBase}/${env.apiPrefix}`,
  // Личность — кука jwt_token, как и у axios (withCredentials: true).
  credentials: 'include',
});

client.use(authMiddleware);

export const { useQuery, useMutation, useSuspenseQuery, queryOptions } =
  createQueryClient<paths>(client);

export default client;
